module.exports = __webpack_public_path__ + "img/31.b9c15663.png";